import angular from 'angular';

import {DataApiService} from './dataApi.service';
import {AppStoreService} from './appStore.service';
import {AppUserService} from './appUser.service';
import {UtilService} from './util.service';

export const ServicesModule = angular
        .module('mmsApp.services', [
        ])
        .service('DataApiService', DataApiService)
        .service('AppStoreService', AppStoreService)
        .service('AppUserService', AppUserService)
        .service('UtilService', UtilService)
        .name
    ;


// WEBPACK FOOTER //
// ./src/app/services/services.module.js